var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFunctionIcon2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 143,
  height: 143,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#function-icon2_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 67.5,
  r: 41.5,
  fill: "#FF9078"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 55,
  width: 44,
  height: 26,
  rx: 2,
  stroke: "#fff",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75.292 67.613a1 1 0 0 1 0 1.774l-4.33 2.25a1 1 0 0 1-1.462-.886v-4.502a1 1 0 0 1 1.461-.887l4.331 2.25Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "function-icon2_svg__a",
  x: 0,
  y: 0,
  width: 143,
  height: 143,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.566083 0 0 0 0 0.470833 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export default SvgFunctionIcon2;